'use strict';

Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });

const react = require('@emotion/react');
const styleEncapsulation = require('@zapier/style-encapsulation');
const utils_createUniqueCustomProperty = require('../../../utils/createUniqueCustomProperty.cjs.js');
const components_display_Table_Vars = require('./Vars.cjs.js');
const styleMixins_reset = require('../../../style-mixins/reset.cjs.js');

const Vars = utils_createUniqueCustomProperty.createUniqueCustomProperties("TableTd", ["frozenCellZindex"]);
const Styles = styleEncapsulation.labelStyles("TableTd", {
  root: react.css`
    ${styleMixins_reset.boxSizing};
    display: table-cell;
    vertical-align: middle;
    // For Safari
    text-align: initial;
    min-height: var(--zds-size-48);

    // tbody cells should always render lowest
    tbody &,
    tbody & {
      ${Vars.frozenCellZindex}: 1;
    }

    // thead cells should always render above tbody cells
    thead &,
    thead & {
      ${Vars.frozenCellZindex}: 2;
    }

    // thead cells that freeze in both directions should always
    // render at the very top
    thead &[data-freeze='row col'],
    thead &[data-freeze='row col'] {
      ${Vars.frozenCellZindex}: 3;
    }

    &[data-freeze~='col'] {
      position: sticky;
      left: 0;
      z-index: var(${Vars.frozenCellZindex}, 1);

      // Render the shadow on a frozen column
      &[data-shadowed~='col'] {
        &::before {
          pointer-events: none;
          content: '';
          display: block;
          position: absolute;
          width: 5px;
          top: 0;
          left: 100%;
          bottom: 0;
          opacity: var(${components_display_Table_Vars.Vars.frozenCellHorzShadowOpacity}, 0);
          transition: all 200ms ease-in-out;
          background: linear-gradient(
            90deg,
            rgba(0, 0, 0, 0.1),
            rgba(0, 0, 0, 0)
          );
        }
      }
    }

    &[data-freeze~='row'] {
      position: sticky;
      top: 0;
      z-index: var(${Vars.frozenCellZindex}, 1);

      // Render the shadow on a frozen row
      &[data-shadowed~='row'] {
        &::after {
          pointer-events: none;
          content: '';
          display: block;
          position: absolute;
          height: 5px;
          top: 100%;
          left: 0;
          width: 100%;
          opacity: var(${components_display_Table_Vars.Vars.frozenCellVertShadowOpacity}, 0);
          transition: all 200ms ease-in-out;
          background: linear-gradient(
            180deg,
            rgba(0, 0, 0, 0.1),
            rgba(0, 0, 0, 0)
          );
        }
      }
    }
  `
});
const TableTd = (props) => {
  return react.jsx("td", { css: [Styles.root, props.className], "data-freeze": props.freeze, "data-shadowed": props.shadowed, "data-zds": true, headers: props.headers, role: "cell" }, props.children);
};

exports.Styles = Styles;
exports.TableTd = TableTd;
//# sourceMappingURL=TableTd.cjs.js.map
